import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="w-full max-w-4xl mx-auto p-4 md:p-8">
      <div className="bg-white shadow-md rounded-xl p-6 md:p-10">
        <h1 className="text-2xl md:text-3xl font-bold text-[#1f3b71] mb-6">
          Terms & Conditions – Dhoorbin.com
        </h1>

        <p className="text-gray-700 leading-relaxed mb-6">
          Welcome to Dhoorbin.com. By accessing our website or using our
          services, you agree to be bound by the following terms and conditions.
        </p>

        {/* 1. General Provisions */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            1. General Provisions
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Nature of Service:</strong> Dhoorbin.com operates as a
              hybrid Online Travel Agency (OTA). We connect customers with
              third-party vendors and provide on-spot support through physical
              service points.
            </li>
            <li>
              <strong>Eligibility:</strong> You must be at least 18 years old
              and have legal authority to enter into an agreement.
            </li>
            <li>
              <strong>Accuracy of Information:</strong> Provide accurate
              information (Name, Mobile Number, ID/Passport) during booking.
              Dhoorbin.com is not liable for service disruptions due to
              incorrect data.
            </li>
          </ul>
        </div>

        {/* 2. Booking & Payment */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            2. Booking & Payment
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Confirmation:</strong> A booking is "Confirmed" only after
              full or required advance payment is successfully processed.
            </li>
            <li>
              <strong>Pricing:</strong> Prices may change by vendors without
              notice, but confirmed bookings are locked at the confirmed price.
            </li>
          </ul>
        </div>

        {/* 3. On-Spot Support & Liability */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            3. On-Spot Support & Liability
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Our Commitment:</strong> Our customer service points and
              representatives assist you in check-ins and ensure service
              delivery.
            </li>
            <li>
              <strong>Vendor Liability:</strong> While we ensure service
              availability, the internal quality (room décor, bus condition,
              food taste) is the vendor’s responsibility. Our on-spot team will
              advocate to resolve discrepancies.
            </li>
            <li>
              <strong>Code of Conduct:</strong> Illegal activities, prohibited
              substances, or anti-social behavior may result in service
              cancellation without refund.
            </li>
          </ul>
        </div>

        {/* 4. Refund & Cancellation Policy */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            4. Refund & Cancellation Policy
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Please refer to our detailed{" "}
            <strong>Refund & Cancellation Policy</strong> for timelines and
            refund percentages.
          </p>
        </div>

        {/* 5. Force Majeure */}
        <div>
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            5. Force Majeure (Unforeseeable Circumstances)
          </h2>
          <p className="text-gray-700 leading-relaxed">
            In cases of natural disasters, political unrest, strikes, or
            pandemics preventing travel, Dhoorbin.com will not issue cash
            refunds. Instead, a Credit Voucher valid for future travel or a free
            date change will be offered.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
